let b 

export const GenerarBufferPDF = (d)=>{
    // console.log(d)
    b = d
  return d
}

export const EnviarBuffer = () =>{
    return b
}

export const RedondearNumero = (value, digitos = 2) => {

  if (value) {
      // let num = value
      // num = Math.round(num * 100) / 100
      // let parts = num?.toString()?.split('.');
      // parts[0] = isNaN(parts[0]) ? '0' : parts[0];

      // if (parts?.length === 1) {
      //     parts.push('00');
      // }

      // if (parts[1]?.length < digitos) {
      //     parts[1] = parts[1] + '0'.repeat(digitos - parts[1].length);
      // }
      // return Number(parts?.join('.'));
      let factor = Math.pow(10, digitos);
      let num = Math.round(value * factor) / factor;
  
      return Number(num?.toFixed(digitos));

  } else {
      return 0
  }
}

export const filtrarActivos = (listaActivos, areasUsuario, userAuth, activoPadre) => {
  return listaActivos.filter(i =>
    i?.ActivoPadre === activoPadre &&
    areasUsuario?.includes(Number(i?.IdArea)) &&
    i?.IdTipoActivo === userAuth?.IdTipoActivo &&
    i?.IdSubTipoActivo === userAuth?.IdSubTipoActivo
  );
};